import UserIcon from '@material-ui/icons/AccountCircle';
import UserList from './UserList';
import UserEdit from './UserEdit';
import UserCreate from './UserCreate';
import UserShow from './UserShow';


export default {
    list: UserList,
    edit: UserEdit,
    create: UserCreate,
    show: UserShow,
    icon: UserIcon,
};
